import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface SetupNameDialogData {
  title: string;
  confirmText: string;
  help?: string;
  placeholder?: string;
  name?: string;
}

@Component({
  selector: 'item-fee-setup-name-dialog',
  templateUrl: './item-fee-setup-name-dialog.component.html',
  styleUrls: ['./item-fee-setup-name-dialog.component.scss'],
  standalone: false,
})
export class ItemFeeSetupNameDialogComponent {
  name: string;
  error = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: SetupNameDialogData,
    private dialogRef: MatDialogRef<ItemFeeSetupNameDialogComponent, string>,
  ) {
    this.name = data.name ?? '';
  }

  confirm(): void {
    if (!this.name?.trim()) {
      this.error = 'Give the setup a name first.';
      return;
    }
    this.dialogRef.close(this.name.trim());
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
